// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-bar {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  width: 100%;
  padding: 30px 0;
  align-items: start;
  gap: 1em;
}

.wrap {
  display: flex;
  justify-content: flex-start;
  gap: 3rem;
  position: relative;
  padding: 2rem 3rem 2.2rem 3rem;
}

.link {
  cursor: pointer;
  font-size: 1.4rem;
  line-height: 140%;
  /* 1.96rem */
  font-weight: 400;
  font-style: normal;
  color: #4C4C4C;
  position: relative;
  padding-bottom: 1rem;
}
.link:after {
  content: "";
  width: 0;
  height: 0.2rem;
  background: var(--primary);
  display: block;
  position: absolute;
  bottom: -0.2rem;
  opacity: 0;
  transition: width 0.3s, opacity 0.3s;
}
.link.active {
  color: var(--black);
}
.link.active:after {
  width: 100%;
  opacity: 1;
}

a,
.tab {
  display: flex;
  gap: 8px;
}

a.disabled {
  pointer-events: none;
  color: gray;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/shared/progress-bar/progress-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qCAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,2BAAA;EACA,SAAA;EACA,kBAAA;EACA,8BAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;AACF;AACE;EACE,WAAA;EACA,QAAA;EACA,cAAA;EACA,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,oCACE;AAAN;AAIE;EACE,mBAAA;AAFJ;AAII;EACE,WAAA;EACA,UAAA;AAFN;;AAOA;;EAEE,aAAA;EACA,QAAA;AAJF;;AAOA;EACE,oBAAA;EACA,WAAA;EACA,qBAAA;AAJF","sourcesContent":[".progress-bar {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  width: 100%;\n  padding: 30px 0;\n  align-items: start;\n  gap: 1em;\n}\n\n.wrap {\n  display: flex;\n  justify-content: flex-start;\n  gap: 3rem;\n  position: relative;\n  padding: 2rem 3rem 2.2rem 3rem;\n}\n\n.link {\n  cursor: pointer;\n  font-size: 1.4rem;\n  line-height: 140%;\n  /* 1.96rem */\n  font-weight: 400;\n  font-style: normal;\n  color: #4C4C4C;\n  position: relative;\n  padding-bottom: 1rem;\n\n  &:after {\n    content: '';\n    width: 0;\n    height: 0.2rem;\n    background: var(--primary);\n    display: block;\n    position: absolute;\n    bottom: -0.2rem;\n    opacity: 0;\n    transition:\n      width 0.3s,\n      opacity 0.3s;\n  }\n\n  &.active {\n    color: var(--black);\n\n    &:after {\n      width: 100%;\n      opacity: 1;\n    }\n  }\n}\n\na,\n.tab {\n  display: flex;\n  gap: 8px;\n}\n\na.disabled {\n  pointer-events: none;\n  color: gray;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
